module.exports = __webpack_public_path__ + "img/img_detail41.41833e0b.png";